import { colors, generateLevelData } from "../../levels/levels";
import * as levelNames from "../../constants/constants";
const levelTwoQuestions = [
  {
    type: "point-or-move",
    specs: {
      arrowColors: "red",
      arrowDirection: "right",
      moveDirection: "left",
      type: "moving",
      answer: 2,
      options: [
        { name: "Up", value: 0 },
        { name: "Down", value: 1 },
        { name: "Left", value: 2 },
        { name: "Right", value: 3 },
      ],
    },
  },
];

export const TutorialLevels = [
  [
    {
      type: levelNames.MATCH,
      specs: {
        correctMessage: <span className='tutorial-incorrect-text'>The meaning and color <span className='tutorial-incorrect-text-color-match'>DO NOT MATCH</span></span>,
        incorrectMessage: <span className='tutorial-incorrect-text'>The meaning and color <span className='tutorial-incorrect-text-color-match'>DO NOT MATCH</span></span>,
        match: "meaning",
        with: "left",
        leftColor: colors.green,
        rightColor: colors.red,
        meaningLeft: "black",
        meaningRight: "black",
        answer: false,
        options: [
          {
            name: "Match",
            value: true,
          },
          {
            name: "Not Match",
            value: false,
          },
        ],
      },
    },
    {
      
      type: levelNames.MATCH,
      specs: {
        correctMessage: <span className='tutorial-incorrect-text'>The meaning and color <span className='tutorial-incorrect-text-color-match'>MATCH</span></span>,
        incorrectMessage: <span className='tutorial-incorrect-text'>The meaning and color <span className='tutorial-incorrect-text-color-match'>MATCH</span></span>,
        match: "meaning",
        with: "left",
        leftColor: colors.blue,
        rightColor: colors.yellow,
        meaningLeft: "yellow",
        meaningRight: "yellow",
        answer: true,
        options: [
          {
            name: "Match",
            value: true,
          },
          {
            name: "Not Match",
            value: false,
          },
        ],
      },
    },
  ],
  [
    {
      type: "pointing",
      specs: {
        correctMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>POINTING</span> in <span className='tutorial-incorrect-text-color-match'>RIGHT</span> direction</span>,
        incorrectMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>POINTING</span> in <span className='tutorial-incorrect-text-color-match'>RIGHT</span> direction</span>,
        arrowColors: "red",
        arrowDirection: "right",
        moveDirection: "left",
        type: "pointing",
        answer: 0,
        options: [],
        message: <span className='tutorial-incorrect-text'>This arrow is <span className='tutorial-incorrect-text-color-match'>POINTING</span> in <span className='tutorial-incorrect-text-color-match'>RIGHT</span> direction</span>
      },
    },
    {
      type: "pointing",
      specs: {
        correctMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>POINTING</span> in <span className='tutorial-incorrect-text-color-match'>UP</span> direction</span>,
        incorrectMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>POINTING</span> in <span className='tutorial-incorrect-text-color-match'>UP</span> direction</span>,
        message: <span className='tutorial-incorrect-text'>What direction are the arrows <span className='tutorial-incorrect-text-color-match'>POINTING?</span><span className='tutorial-incorrect-text-color-match'></span></span>,
        arrowColors: "red",
        arrowDirection: "up",
        moveDirection: "left",
        type: "pointing",
        answer: 0,
        options: [
          { name: "Up", value: 0 },
          { name: "Down", value: 1 },
          { name: "Left", value: 2 },
          { name: "Right", value: 3 },
        ],
      },
    },
    {
      type: "pointing",
      specs: {
        correctMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>POINTING</span> in <span className='tutorial-incorrect-text-color-match'>DOWN</span> direction</span>,
        incorrectMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>POINTING</span> in <span className='tutorial-incorrect-text-color-match'>DOWN</span> direction</span>,
        message: <span className='tutorial-incorrect-text'>What direction are the arrows <span className='tutorial-incorrect-text-color-match'>POINTING?</span><span className='tutorial-incorrect-text-color-match'></span></span>,
        arrowColors: "red",
        arrowDirection: "down",
        moveDirection: "down",
        type: "pointing",
        answer: 1,
        options: [
          { name: "Up", value: 0 },
          { name: "Down", value: 1 },
          { name: "Left", value: 2 },
          { name: "Right", value: 3 },
        ],
      },
    },
    {
      type: "point-or-move",
      specs: {
        correctMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>MOVING</span> in <span className='tutorial-incorrect-text-color-match'>RIGHT</span> direction<span className='tutorial-incorrect-text-color-match'></span></span>,
        incorrectMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>MOVING</span> in <span className='tutorial-incorrect-text-color-match'>RIGHT</span> direction<span className='tutorial-incorrect-text-color-match'></span></span>,
        arrowColors: "red",
        arrowDirection: "right",
        moveDirection: "left",
        type: "point-or-move",
        answer: 0,
        options: [],
        message: <span className='tutorial-incorrect-text'>This arrow is <span className='tutorial-incorrect-text-color-match'>MOVING</span> in the <span className='tutorial-incorrect-text-color-match'>LEFT</span> direction<span className='tutorial-incorrect-text-color-match'></span></span>
      },
    },
    {
      type: "point-or-move",
      specs: {
        correctMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>MOVING</span> in <span className='tutorial-incorrect-text-color-match'>DOWN</span> direction<span className='tutorial-incorrect-text-color-match'></span></span>,
        incorrectMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>MOVING</span> in <span className='tutorial-incorrect-text-color-match'>DOWN</span> direction<span className='tutorial-incorrect-text-color-match'></span></span>,
        arrowColors: "red",
        arrowDirection: "right",
        moveDirection: "down",
        type: "Moving",
        answer: 1,
        options: [
          { name: "Up", value: 0 },
          { name: "Down", value: 1 },
          { name: "Left", value: 2 },
          { name: "Right", value: 3 },
        ],
      },
    },
    {
      type: "point-or-move",
      specs: {
        correctMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>MOVING</span> in <span className='tutorial-incorrect-text-color-match'>UP</span> direction<span className='tutorial-incorrect-text-color-match'></span></span>,
        incorrectMessage: <span className='tutorial-incorrect-text'>The arrows are <span className='tutorial-incorrect-text-color-match'>MOVING</span> in <span className='tutorial-incorrect-text-color-match'>UP</span> direction<span className='tutorial-incorrect-text-color-match'></span></span>,
        arrowColors: "red",
        arrowDirection: "right",
        moveDirection: "up",
        type: "Moving",
        answer: 0,
        options: [
          { name: "Up", value: 0 },
          { name: "Down", value: 1 },
          { name: "Left", value: 2 },
          { name: "Right", value: 3 },
        ],
      },
    },
  ],
];
